// extracted by mini-css-extract-plugin
export default {"navItem":"MenuItem_navItem__XUTti","active":"MenuItem_active__F81Fy","normal":"MenuItem_normal__iHM9v","small":"MenuItem_small__EE00a"};